import { useCMSPageField } from '@/cms/fields'

import { createAdditionalDetailsEvent } from '@/domain/prices/analytics/index'
import { usePromotedPrice } from '@/domain/prices/promoted-price/hooks'
import { usePricesStore } from '@/infrastructure/prices/usePricesStore'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { formatParticipantDistributionToGA4Result } from '@/scopes/search/search/domain/analytics/mappers'
import * as React from 'react'

export function useSendAdditionalDetails() {
  const { data, isFetching } = usePromotedPrice()
  const { sendEvent } = useAnalytics()
  const pricetableAnalytics = useCMSPageField('PDP.pricetable.analytics')
  const { filterSelection } = usePricesStore()
  const { TransportType, Mealplan, Participants } = filterSelection

  const sendAdditionalDetailsEvent = React.useCallback(() => {
    if (!pricetableAnalytics)
      return
    const { accoId, cityId, regionId, countryId } = pricetableAnalytics
    const { distribution: partyComposition, total: totalGuests } = formatParticipantDistributionToGA4Result(
      Participants || [],
    )
    sendEvent(
      createAdditionalDetailsEvent({
        accoId: `${accoId}`,
        transport: TransportType ?? '',
        boardType: Mealplan ?? '',
        duration: data?.duration ? `${data.duration}` : '',
        partyComposition,
        totalGuests,
        cityId,
        regionId,
        countryId,
        departureDate: data?.departureDate ? `${data.departureDate.date}` : '',
        entryPrice: data?.price ? `${data.price.value}` : '',
        campaignId: data?.campaignId || '',
      }),
    )
  }, [data, Mealplan, Participants, TransportType, pricetableAnalytics, sendEvent])

  React.useEffect(() => {
    if (Boolean(data?.accommodationId) && !isFetching) {
      sendAdditionalDetailsEvent()
    }
  }, [data?.price.value])

  return {
    sendAdditionalDetailsEvent,
  }
}
